import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './FooterStatsBar.scss';
import { getCurrencies, isLab } from '../../../../redux/stateSelectors';
import * as moveToCurrentActions from '../../actions/moveToCurrentStats';

const propTypes = {
  visible: PropTypes.bool,
  stats: PropTypes.object,
  showSummaryDetails: PropTypes.func,
  hideSummaryStats: PropTypes.func,
  jobRangeModel: PropTypes.object,
  currencies: PropTypes.array
};

export class FooterStatsBar extends Component {
  static propTypes = propTypes;

  render() {
    const {
      visible,
      showSummaryDetails,
      hideSummaryStats,
      stats,
      jobRangeModel,
      currencies,
      isLab,
      isNavOpen
    } = this.props;
    const modelCurrencyId = jobRangeModel && jobRangeModel.currencyId;
    const selectedCurrency = currencies.find(curr => curr.id === modelCurrencyId) || {
      id: '%',
      name: 'All Currencies',
      code: '%'
    };
    const resultStats = stats || {};

    return (
      <div
        className={classnames('jobRanges-summary-stats-bar', {
          visible: visible,
          isLab: isLab,
          'modified__stats-bar': isNavOpen
        })}
      >
        <div className="stat-job-range-name-container">
          <div className="icon-border icon-circle-thin jbr__checkmark-icon">
            <i className="icon-check" />
          </div>
          <div className="stat-container model-name">
            <span className="stat-heading">Job Based Ranges Completed for</span>
            <span className="stat-text">{`${jobRangeModel?.name} ${selectedCurrency.name}`}</span>
          </div>
        </div>
        <div className="model__stats">
          <div className="stat-container">
            <span className="stat-heading">Jobs in Model</span>
            <span className="stat-number">{resultStats.oss_insert_count || 0}</span>
          </div>
          <div className="stat-container">
            <span className="stat-heading">Ranges Updated</span>
            <span className="stat-number">{resultStats.proposed_jobs_count || 0}</span>
          </div>
          <div className="stat-container">
            <span className="stat-heading">Ranges Not Updated</span>
            <span className="stat-number not-moved">{resultStats.jobs_not_moved_count || 0}</span>
          </div>
        </div>
        <div className="stat-container view-details-button">
          {resultStats.jobs_not_moved_count ? (
            <button className="pxl-btn pxl-btn-default" onClick={showSummaryDetails}>
              View Details
            </button>
          ) : null}
          <i className="icon-cancel" onClick={hideSummaryStats} />
        </div>
      </div>
    );
  }
}

const connectState = state => ({
  ...state.jobRanges.moveToCurrentStats,
  jobRangeModel: state.jobRanges.modelDetails.jobRangeModel,
  currencies: getCurrencies(state),
  isLab: isLab(state)
});
const actions = { ...moveToCurrentActions };
export default connect(connectState, actions)(FooterStatsBar);
